import React from 'react';
import { motion } from 'framer-motion';
import YouTube from 'react-youtube';

// Static config (module scope = stable refs across renders)
const videos = [
  { id: 'NGXPKRcY9II' },
  { id: 'v-PqKeARfg8' },
  { id: '5U-JcITXaHo' },
  { id: 'a8iXy2tmp7A' },
  { id: 'EQgDHjo2I5A' }
];

const youtubeOpts = {
  width: '100%',
  height: '100%',
  playerVars: {
    autoplay: 0,
    modestbranding: 1,
    rel: 0
  }
};

const fadeInUpOnView = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true }
};

const fadeInOnView = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true }
};

const cardFadeOnView = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true }
};

export const VideoGallery = () => {
  return (
    <section id="videos" className="py-24 bg-[#061324]" data-testid="videos-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          {...fadeInUpOnView}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-[#C9A84C] mb-4">
            Training Content
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
            data-testid="videos-title"
          >
            Videos
          </h2>
          <p className="text-base md:text-lg text-[#94A3B8] max-w-2xl mx-auto">
            Watch training clips, drill breakdowns, and camp footage. Subscribe to our YouTube channel for more content.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video, index) => (
            <motion.div
              key={video.id}
              {...cardFadeOnView}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
              data-testid={`video-card-${index}`}
            >
              <div className="bg-[#0A2240] border border-white/10 rounded-sm overflow-hidden card-hover-effect">
                <div className="relative aspect-video bg-black">
                  <YouTube videoId={video.id} opts={youtubeOpts} className="w-full h-full" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          {...fadeInOnView}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <a
            href="https://www.youtube.com/@mattpughpuresweatbasketbal6908"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#C9A84C] text-[#061324] px-8 py-4 rounded-sm font-bold uppercase tracking-wide text-sm hover:bg-[#d8b655] transition-colors gold-glow"
            data-testid="youtube-subscribe-button"
          >
            Subscribe on YouTube
          </a>
        </motion.div>
      </div>
    </section>
  );
};